// user.roles มีทั้ง string ("admin") และ array (["Admin"]) — normalize ก่อนเช็คเสมอ
const normalizeRoles = (roles) => {
  if (!roles) return []
  const arr = Array.isArray(roles) ? roles : [roles]
  return arr.filter((r) => typeof r === "string").map((r) => r.toLowerCase())
}

export const isSuperAdmin = (user) =>
  !!user && normalizeRoles(user.roles).includes("superadmin")

// SuperAdmin ทำได้ทุกอย่างที่ Admin ทำได้
export const isAdmin = (user) =>
  !!user &&
  normalizeRoles(user.roles).some((r) => r === "admin" || r === "superadmin")

export const ROLE_OPTIONS = ["Guest", "Admin", "SuperAdmin"]
